if (!customElements.get("mega-menu-dropdown")) {
  class MegaMenuDropdown extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.closest("header-menu")) return;

      // Getting the parent under which we need to show the menu
      this.targetLocationSelector = this.dataset.targetLocation;
      this.targetLocation = document.querySelector(this.targetLocationSelector);

      if (this.targetLocation) {
        this.targetLocation.innerHTML = "";
        // Move the current element to the target location
        this.targetLocation.appendChild(this);
        this.classList.remove("hidden");
      }
    }
  }

  customElements.define("mega-menu-dropdown", MegaMenuDropdown);
}

// On mobile, inject mega menu image blocks into the menu drawer
function injectImagesMobile() {
  // Only run on mobile (adjust breakpoint as needed)
  if (window.innerWidth >= 1024) {
    return;
  }
  // Find all mega-menu-dropdown elements
  const megaMenus = document.querySelectorAll("mega-menu-dropdown");

  megaMenus.forEach((menu) => {
    // Get the link title this menu is for (e.g Jackets)
    const targetLocation = menu.dataset.targetLocation;
    const match = targetLocation?.match(/data-link-title=([\w-]+)/);
    const targetTitle = match ? match[1] : null;
    // If no match
    if (!targetTitle) {
      return;
    }

    // Find the corresponding drawer submenu by link handle
    const drawerSubmenu = document.querySelector(`#link-${targetTitle}`);
    if (!drawerSubmenu) {
      return;
    }

    // Find the <ul> inside the submenu
    const ul = drawerSubmenu.querySelector("ul");
    if (!ul) {
      return;
    }

    // Remove previously injected image blocks
    ul.querySelectorAll(".mega-menu-image-block-mobile").forEach((el) =>
      el.remove()
    );

    // Find image blocks inside the mega menu dropdown
    const imageBlocks = menu.querySelectorAll(".mega-menu-image-block");
    imageBlocks.forEach((block, idx) => {
      const li = document.createElement("li");
      li.className =
        "mega-menu-image-block-mobile overflow-hidden " +
        (idx === 0 ? "py-0" : "py-4");
      li.appendChild(block.cloneNode(true));
      ul.appendChild(li);
    });
  });
}

document.addEventListener("DOMContentLoaded", injectImagesMobile);
window.addEventListener("resize", function () {
  // if becomes mobile
  if (window.innerWidth < 1024) {
    injectImagesMobile();
  }
});
